import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box } from "@chakra-ui/react";
import { darkBg, inspireYellow, lightGrayBg } from "@inspire/ui/static";
var Row = function(_param) /*#__PURE__*/ {
    var children = _param.children, variant = _param.variant, boxProps = _object_without_properties(_param, [
        "children",
        "variant"
    ]);
    return _jsx(Box, _object_spread_props(_object_spread({
        flex: 1,
        display: "flow-root" // To contain margins of children
    }, variant === "gray" ? {
        backgroundColor: lightGrayBg
    } : variant === "dark" ? {
        backgroundColor: darkBg
    } : variant === "yellow" ? {
        backgroundColor: inspireYellow
    } : {
        backgroundColor: "white"
    }, boxProps), {
        children: children
    }));
};
export default Row;
